module.exports = __webpack_public_path__ + "static/yoox_negativo-0ad4605195662a781701422e1be9a321.png";